// extracted by mini-css-extract-plugin
module.exports = {"figure":"Img_figure__3Xe0o","img":"Img_img__2eXIa","imgNotFound":"Img_imgNotFound__nOcF3","anim":"Img_anim__3VuZh","fade1":"Img_fade1__3XJud","fade2":"Img_fade2__JIpVb"};